import { render, staticRenderFns } from "./RelatorioSubTotal.vue?vue&type=template&id=16011e40&"
import script from "./RelatorioSubTotal.vue?vue&type=script&lang=js&"
export * from "./RelatorioSubTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports